export class BadgeStatusColor {
  public static Yellow = 'yellow';
  public static Green = 'green';
  public static Grey = 'grey';
  public static Red = 'red';
}
